import { MopedOutlineIcon } from './MopedOutlineIcon';

/**
 * author: Google
 * id 2C84B4E2-F872-423E-B9E2-918DD013E131
 * name moped-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moped-outline.svg
 * tags
 * - Transportation + Road 
 */
export const DeliveryDiningOutlineIcon = MopedOutlineIcon;
export default DeliveryDiningOutlineIcon